import Swiper, { Navigation } from 'swiper/core';

// configure Swiper to use modules
Swiper.use([Navigation]);

export default class SwiperImage {
  constructor(swiperEl) {
    this.dom = {
      swiper: swiperEl,
    };

    this.data = {
      swiperConfig: {
        loop: true,
        slidesPerView: 1,
        loadPrevNextAmount: 3,
        initialSlide: Math.floor([...swiperEl.querySelectorAll('.swiper-slide')].length / 2),
        spaceBetween: 0,
        centeredSlides: true,
        freeMode: true,
        grabCursor: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        breakpoints: {
          576: {
            navigation: {
              prevEl: '.carousel-image .swiper-button-prev',
            },
          },
        },
      },
    };

    this.components = {
      swiperInstance: null,
    };

    this.mount();
  }

  mount() {
    this.components.swiperInstance = new Swiper(this.dom.swiper, this.data.swiperConfig);
  }
}
